/* eslint-disable */
<template>
  <div>
    
    <b-row class="row-align-left">
      <b-col sm="4">
        <label for="rdTestedGlucose">
          Was a Glucose test done?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isTestedGlucoseState || isA1cGlucoseState }"
                name="rdTestedGlucose"
                value="true"
                v-model="$v.isTestedGlucose.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isTestedGlucoseState }"
                name="rdTestedGlucose"
                value="false"
                v-model="$v.isTestedGlucose.$model"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="2">
          <b-form-input
            v-if="isTestedGlucose === 'true'"
            type="number"
            min="0"
            step="0.1"
            rel="txtGlucoseReading"
            id="txtGlucoseReading"
            placeholder="Glucose Results"
            v-model="glucoseReading"
            :state="glucoseReadingState"
          ></b-form-input>
      </b-col>
    </b-row>

    
    <b-row class="row-align-left"> 
      <b-col sm="4">
        <label for="rdTestedA1C">
          Was an A1C test done?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isTestedA1CState }"
                name="rdTestedA1C"
                value="true"
                v-model="$v.isTestedA1C.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isTestedA1CState }"
                name="rdTestedA1C"
                value="false"
                v-model="$v.isTestedA1C.$model"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="2">
        <b-form-input
          v-if="isTestedA1C === 'true'"
          type="number"
          min="0"
          step="0.1"
          id="txtA1cNumber"
          placeholder="A1C Results"
          v-model.number="a1CNumber"
          :state="a1CNumberState"
        ></b-form-input>
      </b-col>
      
    </b-row>

    <b-row class="row-align-left"> 
      <b-col sm="4">
        <label for="rdTestedLipids">
          Was a Lipid test done?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isTestedLipidsState }"
                name="rdTestedLipids"
                value="true"
                v-model="$v.isTestedLipids.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isTestedLipidsState }"
                name="rdTestedLipids"
                value="false"
                v-model="$v.isTestedLipids.$model"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="isTestedLipids === 'true'">
      <h4>Lipids Test Results</h4>
      <b-col md="12">
      <b-row>
        
        <b-col md="2">
          <label for="txtChol">Total Cholesterol</label>
        </b-col>
        <b-col md="2">
          <b-form-input
            type="number"
            min="0"
            step="0.1"
            id="txtChol"
            v-model="lipidsChol"
            :state="lipidsChol_State"
          ></b-form-input>
        </b-col>
        
        <b-col md="2">
          <label for="txtHdlC">HDL</label>
        </b-col>
        <b-col md="2">
          <b-form-input
            type="number"
            min="0"
            step="0.1"
            id="txtHdlC"
            v-model="lipidsHdlC"
            :state="lipidsHdlC_State"
          ></b-form-input>
        </b-col>
        <b-col md="2">
          <label for="txtLdlC">LDL</label>
        </b-col>
        <b-col md="2">
          <b-form-input
            type="number"
            min="0"
            step="0.1"
            id="txtLdlC"
            v-model="lipidsLdlC"
            :state="lipidsLdlC_State"
          ></b-form-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        
        <b-col md="2">
          <label for="txtTrig">Triglycerides</label>
        </b-col>
        <b-col md="2">
          <b-form-input
            type="number"
            min="0"
            step="0.1"
            id="txtTrig"
            v-model="lipidsTrig"
            :state="lipidsTrig_State"
          ></b-form-input>
        </b-col>
        <b-col md="2">
          <label for="txtCholHdl">Total Cholesterol/HDL Ratio</label>
        </b-col>
        <b-col md="2">
          <b-form-input
            type="number"
            min="0"
            step="0.1"
            id="txtCholHdl"
            v-model="lipidsCholHdl"
            :state="lipidsCholHdl_State"
          ></b-form-input>
        </b-col>
      </b-row>
      </b-col>
    </b-row>
    <b-row>
      <h4>Blood Pressure Reading</h4>
      <b-col md="12">
        <b-row>
          <b-col md="3">
            <label for="txtSystolic">Systolic or Top Number</label>
          </b-col>
          <b-col md="2">
            <b-form-input
              type="number"
              min="0"
              step="0.1"
              id="txtSystolic"
              v-model="bpSystolic"
              :state="bpSystolicState"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <label for="txtDiastolic">Diastolic or Bottom Number</label>
          </b-col>
          <b-col md="2">
            <b-form-input
              type="number"
              min="0"
              step="0.1"
              id="txtDiastolic"
              v-model="bpDiastolic"
              :state="bpDiastolicState"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-col>
      
    </b-row>
    <b-row>
      <label for="txtComment">Comment:</label>
      <b-form-textarea id="txtComment" v-model="$v.comment.$model" placeholder="Please enter a comment"></b-form-textarea>
    </b-row>
    

    <survey-nav
      :step="8"
      :ShowErrorMsg="showErrorMsg"
      @move-next="moveNext"
      @move-previous="movePrevious"
    ></survey-nav>
  </div>
</template>

<script>
import surveyNav from "@/components/SurveyNav";
import { required } from "vuelidate/lib/validators";

export default {
  name: "survey-step8",
  props: ["surveyData", "isValid"],
  data: () => ({
    showErrorMsg: false,
    lipidsChol: null,
    lipidsTrig: null,
    lipidsLdlC: null,
    lipidsHdlC: null,
    lipidsCholHdl: null,
    a1CNumber: null,
    glucoseReading: null,
    comment: null,
    isTestedA1C: null,
    isTestedGlucose: null,    
    isTestedLipids: null,
    bpSystolic: null,
    bpDiastolic: null
  }),
  validations: {
    isTestedA1C: {
      required
    },
    isTestedGlucose: {
      required
    },
    isTestedLipids: {
      required
    },
    comment: {
      
    },
    bpSystolic: {
      
    },
    bpDiastolic: {

    }
  },
  components: {
    surveyNav
  },
  methods: {
    moveNext() {
      if (this.validateForm()) this.$emit("move-next");
      else {
        this.showErrorMsg = true;
        this.$v.$touch();
      }
    },
    movePrevious() {
      this.$emit("move-previous");
    },
    onCreated() {
      this.isTestedA1C = this.surveyData.IsTestedA1C;
      this.isTestedGlucose = this.surveyData.IsTestedGlucose;
      this.isTestedLipids = this.surveyData.IsTestedLipids;
      this.glucoseReading = this.surveyData.GlucoseReading;
      this.a1CNumber = this.surveyData.A1CNumber;
      this.lipidsCholHdl = this.surveyData.LipidsCholHdl;
      this.lipidsLdlC = this.surveyData.LipidsLdlC;
      this.lipidsTrig = this.surveyData.LipidsTrig;
      this.lipidsChol = this.surveyData.LipidsChol;
      this.lipidsHdlC = this.surveyData.LipidsHdlC;
      this.bpSystolic = this.surveyData.BpSystolic;
      this.bpDiastolic = this.surveyData.BpDiastolic;
      this.comment = this.surveyData.Comment;
    },
    validateForm() {
      if(this.$v.$invalid) return false; //the initial validations failed
      if(this.isTestedGlucose == "true" && !this.glucoseReading ) return false;
      if(this.isTestedA1C == "true" && !this.a1CNumber ) return false;
      if(this.isTestedA1C == "true" && this.a1CNumber > 7.5 && (this.isTestedGlucose == null || this.isTestedGlucose == "false" || !this.glucoseReading)) return false;
      if(this.isTestedLipids == "true" && !this.lipidsCholHdl ) return false;
      if(this.isTestedLipids == "true" && !this.lipidsHdlC ) return false;
      if(this.isTestedLipids == "true" && !this.lipidsLdlC ) return false;
      if(this.isTestedLipids == "true" && !this.lipidsTrig ) return false;
      if(this.isTestedLipids == "true" && !this.lipidsChol ) return false;
      return true; //the form is valid
    }
  },
  computed: {
    isTestedGlucoseState(){
      return this.$v.isTestedGlucose.$dirty
          ? !this.$v.isTestedGlucose.required
          : null;
    },
    isA1cGlucoseState() {
      return this.isTestedA1C == "true" && this.a1CNumber > 7.5 && (this.isTestedGlucose == null || this.isTestedGlucose == "false" || !this.glucoseReading);
    },
    glucoseReadingState() {
      if(this.isTestedGlucose == "true"){
        if(!this.glucoseReading) return false;
        return true;
      }
      else {
        return null;
      }
    },
    isTestedA1CState(){
      return this.$v.isTestedA1C.$dirty
          ? !this.$v.isTestedA1C.required
          : null;
    },
    a1CNumberState() {
      if(this.isTestedA1C == "true"){
        if(!this.a1CNumber) return false;
        return true;
      }
      else{
        return null;
      }
    },
    isTestedLipidsState(){
      return this.$v.isTestedLipids.$dirty
          ? !this.$v.isTestedLipids.required
          : null;
    },
    
    lipidsCholHdl_State() {
      if(this.isTestedLipids == "true"){
        if(!this.lipidsCholHdl) return false;
        return true;
      }
      else {
        return null;
      }
    },
    lipidsLdlC_State() {
      if(this.isTestedLipids == "true"){
        if(!this.lipidsLdlC) return false;
        return true;
      }
      else {
        return null;
      }
    },
    lipidsTrig_State() {
      if(this.isTestedLipids == "true"){
        if(!this.lipidsTrig) return false;
        return true;
      }
      else {
        return null;
      }
    },
    lipidsChol_State() {
      if(this.isTestedLipids == "true"){
        if(!this.lipidsChol) return false;
        return true;
      }
      else {
        return null;
      }
    },
    lipidsHdlC_State() {
      if(this.isTestedLipids == "true"){
        if(!this.lipidsHdlC) return false;
        return true;
      }
      else {
        return null;
      }
    },
    bpSystolicState(){
      return this.$v.bpSystolic.$dirty
          ? !this.$v.bpSystolic.required
          : null;
    },
    bpDiastolicState(){
      return this.$v.bpDiastolic.$dirty
          ? !this.$v.bpDiastolic.required
          : null;
    },
  },
  watch: {
    glucoseReading() {
      if (this.glucoseReading)
        this.surveyData.GlucoseReading = this.glucoseReading;
    },
    a1CNumber() {
      if (this.a1CNumber)
        this.surveyData.A1CNumber = this.a1CNumber;
    },
    lipidsCholHdl() {
      if (this.lipidsCholHdl)
        this.surveyData.LipidsCholHdl = this.lipidsCholHdl;
    },
    lipidsLdlC() {
      if (this.lipidsLdlC)
        this.surveyData.LipidsLdlC = this.lipidsLdlC;
    },
    lipidsTrig() {
      if (this.lipidsTrig)
        this.surveyData.LipidsTrig = this.lipidsTrig;
    },
    lipidsChol() {
      if (this.lipidsChol)
        this.surveyData.LipidsChol = this.lipidsChol;
    },
    lipidsHdlC() {
      if (this.lipidsHdlC)
        this.surveyData.LipidsHdlC = this.lipidsHdlC;
    },
    comment() {
      if (this.$v.comment)
        this.surveyData.Comment = this.comment;
    },
    isTestedA1C() {
       if (this.$v.isTestedA1C)
        this.surveyData.IsTestedA1C = this.isTestedA1C;
    },
    isTestedGlucose(){
      if (this.$v.isTestedGlucose)
        this.surveyData.IsTestedGlucose = this.isTestedGlucose;

    },
    isTestedLipids(){
      if(this.$v.isTestedLipids)
        this.surveyData.IsTestedLipids = this.isTestedLipids;
    },
    bpSystolic() {
      if (this.$v.bpSystolic)
        this.surveyData.BpSystolic = this.bpSystolic;
    },
    bpDiastolic() {
      if (this.$v.bpDiastolic)
        this.surveyData.BpDiastolic = this.bpDiastolic;
    }
  },
  created() {
    this.onCreated();
  }
};
</script>
<style>

</style>

